import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { isNullOrUndefined } from '@uzurv/core';

@Component({
  selector: 'app-ride-status-chip',
  templateUrl: './ride-status-chip.component.html',
  styleUrls: ['./ride-status-chip.component.scss']
})
export class RideStatusChipComponent implements OnInit {
  @Input() status: string;
  @Input() isAction: boolean = false;

  @Output() rideStatusChipClicked = new EventEmitter<string>();

  constructor() {}

  ngOnInit(): void {}

  get strippedStatus(): string {
    if (isNullOrUndefined(this.status)) {
      return '';
    }

    return this.status.replace(/ /g, '');
  }

  handleRideStatusChipClicked() {
    this.rideStatusChipClicked.emit(this.status);
  }
}
